import { Button, ButtonGroup } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import autobind from "autobind-decorator";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import styled from "styled-components";

import CssUnitWidget from "common/form/widgets/CssUnitWidget";
import * as configActions from "core/actions/configActions";
import { IColumn } from "./LayoutField";

interface IColumnsEdit {
	columns: IColumn[];
	onChange: (columns: IColumn[]) => void;
	actions?: any;
}

class ColumnsEdit extends React.PureComponent<IColumnsEdit> {

	@autobind
	private addCol() {
		const columns = this.props.columns || [];
		const size = columns.length;

		if(!(size < 20)) {
			return; // no more than 20 columns
		}

		// create the panel then add it to the list of children for this container
		this.props.actions.configPanelCreate("container", {inLayout: true}, (instance) => {

			// new column with default width and instance from container just created
			const column = {width: "1fr", breakPoint: "700px", containerInstance: instance};

			// add to this layout
			this.props.onChange([...columns, column]);
		});
	}

	@autobind
	private removeCol() {
		const columns = this.props.columns || [];
		const size = columns.length;

		if(!(size > 1) || !confirm("Removing this column will remove all panels in")) {
			return; // must be 1 or more cols
		}

		// remove col
		this.props.onChange(columns.slice(0, size - 1));
	}

	@autobind
	private editCol(width: string, index: number) {
		const cols = (this.props.columns || []).map((c, i) => (i === index) ? {...c, width} : c);
		this.props.onChange([...cols]);
	}

	public render() {

		const columns = this.props.columns || [];

		const grid: string[] = [];

		const columnEdits = columns.map((c, i) => {
			grid.push("auto");

			// use 1/4 of the line
			const Column = styled.div`
				flex: 1 0 25%;
				padding: 0 5px 5px 0;

				&:last-child, &:nth-child(4n) {
					padding-right: 0;
				}
			`;

			return (
				<Column key={i}>
					<CssUnitWidget value={c.width} onChange={(v) => this.editCol(v, i)} readonly={false} autofocus={false} options={undefined} />
				</Column>
			);
		});

		/* const ColumnsCont = styled.div`
			display: grid;
			grid-gap: 5px;
			grid-template-columns: ${grid.join(" ")};
		`; */

		const ColumnsCont = styled.div`
			display: flex;
			flex-wrap: wrap;
		`;

		const Header = styled.div`
			display: flex;
			align-items: baseline;
			justify-content: space-between;
			margin-bottom: 10px;

			@media (max-width: 300px) {
				flex-direction: column;
				align-items: left;
			}
		`;

		return (
			<div>
				<Header>
					<h5>
						Columns ({columns.length})
					</h5>
					<div>
						<ButtonGroup minimal={true}>
							<Button
								icon={IconNames.PLUS}
								small={true}
								disabled={columns.length >= 20}
								onClick={this.addCol} />
							<Button
								icon={IconNames.MINUS}
								small={true}
								disabled={columns.length <= 1}
								onClick={this.removeCol}
							/>
						</ButtonGroup>
					</div>
				</Header>

				<ColumnsCont>
					{columnEdits}
				</ColumnsCont>
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch) => {
	return { actions: bindActionCreators(configActions as any, dispatch) };
};

export default connect<IColumnsEdit>(undefined, mapDispatchToProps)(ColumnsEdit);



// WEBPACK FOOTER //
// ./src/common/form/fields/layoutField/ColumnsEdit.tsx